import React, { useState, useEffect } from 'react'
import axiosService from "../../utils/axios.service";
import Avatar from 'react-avatar';
import _ from 'lodash';
import * as convert from "../constant/Convert.helper";
import { format } from "date-fns"
import "./scss/familypopup.scss";
import { notifications } from "../constant/Notify";
import { Spin } from 'antd';

export function FamilyPopup(props) {
  const [statusSearchCustomer, setStatusSearchCustomer] = useState(false);
  const [dataSearchCustomer, setDataSearchCustomer] = useState([]);
  const [loading, setLoading] = useState(false);
  const [owner, setOwner] = useState(props.customer.id === props.package.customer_id);

  const searchCustomer = _.debounce(async (event) => {
    let keyword = event.target.value;
    if (keyword.length >= 2) {
      let {data} = await axiosService("api/customer?keyword=" + keyword, "GET")
      if (data.success) {
        const response = data.data.data;
        setDataSearchCustomer(response ?? []);
        setStatusSearchCustomer(true);
      }
    }
  }, 500);

  const getDetailCustomer = (data, type) => {
    props.setListFamily((prev) => {
      if (type === "add") {
        const isExist = prev.some((item) => item.id === data.id);
        if (isExist || props.listFamily.length === props.package.product.number_family || props.customer.id === data.id) return prev;
        return [...prev, data];
      }

      if (type === "remove") {
        return prev.filter((item) => item.id !== data.id);
      }

      return prev;
    });
  };


  const changePackageFamily = async () => {
    setLoading(true)
    let payload = {
      id: props.package.id,
      customer_list: props?.listFamily
    }
    let response = await axiosService("api/package/update-customer-family", "POST", payload)

    if (response.data.code == 200) {
      let listFamily = []
      let listAll = [{value: 0, label: "Tất cả"}]
      response.data.data.map((item, index) => {
        if (!item.family_delete) listFamily.push(item)
        listAll.push({value: item.id, label: `${item.full_name} - ${item.mobile}`})
      })
      props.setListFamily(listFamily)
      props.setAllFamily(listAll)
        
      notifications({ type: 'success', mess: 'Đổi danh sách thành công' });
      setLoading(false)
    } else {
      notifications({ type: 'error', mess: 'Đã có lỗi' });
      setLoading(false)
    }
  }
    
  return (
    <Spin spinning={loading} size="large" tip="Đang tải...">
      <div onClick={() => {setStatusSearchCustomer(false)}}>
        <div className="head-popup">
          <div className="title">{`Danh sách đồng sở hữu thẻ (Tối đa: ${props.package.product.number_family} khách)`}</div>
        </div>
        <div className="body-popup">
          <div className="family-change">
              <div className="search-family">
                {owner ?
                  <>
                    <div className="label">{`Chọn khách đồng sở hữu`}</div>
                    <input className="input-search-cus" placeholder="Tìm khách hàng theo tên hoặc số điện thoại" type="text" onChange={searchCustomer}/>
                  </>
                :null}

                {statusSearchCustomer === true ? 
                  <div className="result-search">
                    {dataSearchCustomer.length === 0 ? 
                      <div className="empty-customer">
                        Không tìm thấy dữ liệu phù hợp
                      </div>
                    : 
                      <div className="items-customer">
                        {dataSearchCustomer.map((data, key) => (
                          <div className="item" key={key} onClick={() => {getDetailCustomer(data, "add")}}>
                            <div className="avatar">
                              {data.avatar_url ?
                                <img src={data.avatar_url} alt="" />
                              : <Avatar name={data.full_name} size="46" textSizeRatio={1.75} round="50%" />}
                            </div>
                            <div className="info">
                              <div className="name">
                                {data.full_name}
                                {data?.identifier === 1 ? <span className="identifier-customer"><img src="/icons/verified.png" /></span> : ""}
                              </div>
                              {data?.waxing_type >= 1 && data?.status_head_waxing === 0 ? <div style={{fontSize: '11px', color: "#999", marginTop: '8px'}}>(Chưa tặng đầu triệt)</div>  : ""}
                              {data.deposit_money > 0 ?
                                <div className="deposit">Tài khoản: {convert.convertCurrency(data.deposit_money)}</div>
                              : null}
                              <div className="phone">{data.mobile}</div>
                              <div className="address">{data.district} - {data.city}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    }
                  </div>
                : null}
              </div>
              <div className="list-family">
                <div className="row">
                  {(props?.listFamily ?? []).map((data, key) => (
                    <div className="col-12 col-md-6" key={key}>
                      <div className="wrapper-item">
                        <div className="column-info">
                          <div className="avatar">
                            {data.avatar_url ?
                              <img src={data.avatar_url} alt="" />
                            : <Avatar name={data.full_name} size="46" textSizeRatio={1.75} round="50%" />}
                          </div>
                          <div className="info">
                            <div className="name">
                              {data.full_name} {props.package.customer_id === data.id ? <i className="fas fa-key" style={{color: "#FEBE18"}}></i> : null}
                            </div>
                            <div className="phone">{data.mobile}</div>
                          </div>
                        </div>
                        {owner && props.package.customer_id !== data.id ? 
                          <div className="column-action" onClick={() => {getDetailCustomer(data, "remove")}}>Xóa</div>
                        :null}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
        </div>
        <div className="bottom-popup">
            <div className="button-container">
                <div onClick={() => {props.setFamilyPopup(false)}} className="button-cent style3">
                    <span><i className="fas fa-times"></i></span> Đóng
                </div>
                {owner ?
                  <div onClick={changePackageFamily} className="button-cent style-history-pay">
                    <span><i className="fas fa-save"></i></span> Lưu
                  </div>
                :null}
            </div>
        </div>
      </div>
    </Spin>
  )
}
